import { useToast } from '~/contexts/ToastProvider'

const ERRORS = {
  ban: 'chk_user_bans',
  reportAlreadyExists: 'hiago_message_reports_message_id_user_id_unique',
}

const useError = () => {
  const { addToast } = useToast()

  const dispatchError = ({ message }) => {
    const errorKey = Object.keys(ERRORS).find(key => message.includes(ERRORS[key])) || 'default'
    addToast('danger', 'errors', `errors.${errorKey}`)
  }

  return {
    dispatchError,
  }
}

export default useError
